exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-KZpu{position:relative;margin-bottom:36px;font-size:14px;font-weight:400;padding-right:8px}._3Cu2e{font-size:17px;font-weight:700;margin-bottom:15px}._1d01p{line-height:1.75;padding-right:20px}.xlFIb{font-size:12px}.PV9iD{display:inline-block;margin-right:20px;width:calc(50% - 20px);vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_11SHK",
	"description": "-KZpu",
	"title": "_3Cu2e",
	"text": "_1d01p",
	"list": "xlFIb",
	"col": "PV9iD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AdvertDescription/AdvertDescription.css
// module id = 2762
// module chunks = 32 36